module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-d2c37e56.png";